// функция открытитя модального окна
function openModal(currentForm) {
  // показываем модальное окно
  currentForm.show();
  currentForm.prev('.form-modal__overlay-list').show();

  // Начинаем слушать клавишу Esc. При её нажатии, закарываем окно.
  $(document).on('keyup', function (e) {
    if (e.keyCode === 27) {
      $('.form-modal__overlay-list, .list-services-modal.form-modal').hide();
    }
  });
}

if ($(document).width() < 769) {
  $('.openListServicesModal').addClass('not-active-link');
  $('.openListServicesModal').removeClass('openListServicesModal');
}

// закрываем модальное окно
$('.closeListServicesModal').click(function () {
  $('.form-modal__overlay-list, .list-services-modal.form-modal').hide();

  // возвращаем скролл страницы в положение "по-умолчанию"
  $('body').css('overflow', 'auto');
});

// при клике по кнопке открытия...
$('.openListServicesModal').click(function (e) {
  e.preventDefault();

  const currentForm = $(this).closest('.product-card__wrapper').children('.list-services-modal');

  // показываем модальное окно
  openModal(currentForm);

  if (currentForm) {

    // убираем скролл страницы, чтобы вертикальный скролл был только у окнна
    $('body').css('overflow', 'hidden');

    // перемещаем скролл к окну
    // $('html, body').animate({scrollTop: currentForm.offset().top - 100 }, 400);
  }
});



// WEBPACK FOOTER //
// ./app/blocks/form-list/form-list.js